import { render, staticRenderFns } from "./Seating.vue?vue&type=template&id=79ef9308&"
import script from "./Seating.vue?vue&type=script&lang=ts&"
export * from "./Seating.vue?vue&type=script&lang=ts&"
import style0 from "./Seating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports